import React, { Component } from "react";
import Chart from "react-apexcharts";
import moment from "moment";
export default class LineGraph extends Component {
  render() {
    const { sensor, kleur } = this.props;
    
    // Prepare data for ApexCharts
    function prepareApexData(data) {
      if (!data || !data.data || !Array.isArray(data.data)) return { currentSeries: [], previousSeries: [], categories: [] };
      
      const currentSeries = [];
      const previousSeries = [];
      const categories = [];

      data.data.forEach(function (a, key) {
        if (a.datum && a.value && key > 0) {
          const currentValue = parseFloat(((data.data[key - 1].value - a.value) / 1000).toFixed(3));
          const timestamp = new Date(a.datum).getTime();
          
          currentSeries.push([timestamp, currentValue]);
          categories.push(timestamp);
          
          if (data.vorigeperoide && data.vorigeperoide[key] && data.vorigeperoide[key - 1]) {
            const previousValue = parseFloat(((data.vorigeperoide[key].value - data.vorigeperoide[key - 1].value) / 1000).toFixed(3));
            previousSeries.push([timestamp, previousValue]);
          } else {
            previousSeries.push([timestamp, 0]);
          }
        }
      });
      
      return { currentSeries, previousSeries, categories };
    }

    const chartData = prepareApexData(sensor || {});
    
    // ApexCharts configuration
    const options = {
      chart: {
        type: 'line',
        height: 300,
        toolbar: {
          show: true,
          tools: {
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true,
            selection: true
          }
        },
        zoom: {
          enabled: true,
          type: 'x',
          autoScaleYaxis: true
        },
        selection: {
          enabled: true,
          type: 'x'
        },
        animations: {
          enabled: false
        }
      },
      colors: [kleur || '#03c3ec', '#8592a3'],
      stroke: {
        curve: 'smooth',
        width: [2, 2],
        dashArray: [0, 5]
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        type: 'datetime',
        labels: {
          format: 'dd MMM HH:mm',
          datetimeUTC: false
        },
        title: {
          text: 'Datum'
        }
      },
      yaxis: {
        title: {
          text: 'Kubieke meter'
        },
        labels: {
          formatter: function (val) {
            return val.toFixed(3);
          }
        }
      },
      tooltip: {
        x: {
          format: 'dd MMM yyyy HH:mm'
        },
        y: {
          formatter: function (val, { seriesIndex }) {
            const period = seriesIndex === 0 ? 'Huidige periode' : 'Vorige periode';
            return `${period}: ${val.toFixed(3)} m³`;
          }
        }
      },
      legend: {
        show: true,
        position: 'top'
      },
      grid: {
        borderColor: '#e7e7e7',
        strokeDashArray: 3
      }
    };

    const series = [
      {
        name: 'Huidige Periode',
        data: chartData.currentSeries
      },
      {
        name: 'Vorige Periode',
        data: chartData.previousSeries
      }
    ];

    return (
      <div style={{ width: '100%', height: '300px' }}>
        {chartData.currentSeries.length > 0 ? (
          <Chart
            options={options}
            series={series}
            type="line"
            height={300}
          />
        ) : (
          <div style={{ 
            height: '300px', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            color: '#666'
          }}>
            Loading Chart...
          </div>
        )}
      </div>
    );
  }
}
